import React from 'react';
import styles from './certsCarousel.module.css';

import c1 from '../../images/students_certificate_1.webp';
import c2 from '../../images/students_certificate_2.webp';
import c3 from '../../images/students_certificate_3.webp';
import c4 from '../../images/students_certificate_4.webp';
import c5 from '../../images/students_certificate_5.webp';
import c6 from '../../images/students_certificate_6.webp';
import c7 from '../../images/students_certificate_7.webp';
import c8 from '../../images/students_certificate_8.webp';
import c9 from '../../images/students_certificate_9.webp';
import c10 from '../../images/students_certificate_10.webp';

const certImages = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10];

const CertsCarousel = ({ small }) => {
  const images = certImages;
  const wrapCls = `${styles.worksImageWrapper} ${small ? styles.small : ''}`;

  return (
    <>
      <div className={styles.explain}>
      </div>

      <div className={`${styles.worksContainer} ${small ? styles.containerSmall : ''}`}>
        <div className={`${styles.worksScrollTrack} ${small ? styles.trackSmall : ''}`}>
          {/* Set 1 */}
          <div className={styles.worksScrollContainer}>
            {images.map((img, index) => (
              <div key={`cert-set1-${index}`} className={wrapCls}>
                <img
                  src={img}
                  alt={`תעודה ${index + 1}`}
                  className={styles.worksImage}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Set 2 - duplicate for seamless loop */}
          <div className={styles.worksScrollContainer}>
            {images.map((img, index) => (
              <div key={`cert-set2-${index}`} className={wrapCls}>
                <img
                  src={img}
                  alt={`תעודה ${index + 1}`}
                  className={styles.worksImage}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CertsCarousel;

